import React, {ReactNode} from "react";
import {Navigate} from "react-router-dom";
import {useAuth} from "features/login/context/AuthProvider";

type Props = {
  showBreadTitle?: boolean;
  children: ReactNode;
};

function ProtectedRouteComponent({
                                   children,
                                 }: Props) {
  const {authenticated, isChecking} = useAuth();

  if (isChecking) {
    return null;
  }

  if (!authenticated) {
    return (<Navigate to="/auth/login" replace />);
  }
  
  return children;
}

export default ProtectedRouteComponent;
